import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { formatDateUS } from "../lib/format";
import { Calendar, Clock, Warning } from "@phosphor-icons/react";
import { toast } from "sonner";

function tone(days) {
    if (days < 0) return { tag: "Overdue", cls: "bg-red-50 text-red-700 border-red-200" };
    if (days <= 7) return { tag: "This week", cls: "bg-amber-50 text-amber-700 border-amber-200" };
    if (days <= 30) return { tag: "This month", cls: "bg-blue-50 text-[#2563EB] border-blue-200" };
    return { tag: "Upcoming", cls: "bg-slate-50 text-slate-600 border-slate-200" };
}

export default function Deadlines() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/deadlines").then((r) => setItems(r.data))
            .catch((e) => toast.error(formatApiError(e)))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="space-y-8" data-testid="deadlines-page">
            <div>
                <p className="overline">Reminders</p>
                <h1 className="font-serif text-4xl sm:text-5xl mt-3 leading-tight font-bold">Upcoming deadlines</h1>
                <p className="text-slate-600 mt-3 max-w-xl">Every case with a deadline date, sorted by urgency. Click a row to open the case.</p>
            </div>

            {loading ? (
                <p className="text-slate-500">Loading…</p>
            ) : items.length === 0 ? (
                <div className="border border-dashed border-slate-300 rounded-md p-12 text-center">
                    <Calendar size={32} weight="duotone" className="mx-auto text-slate-400" />
                    <p className="mt-4 text-slate-600">No cases have a deadline set yet.</p>
                </div>
            ) : (
                <div className="space-y-3" data-testid="deadlines-list">
                    {items.map((it) => {
                        const t = tone(it.days_until);
                        return (
                            <Link key={it.id} to={`/cases/${it.id}`} data-testid={`deadline-${it.id}`}
                                className={`flex items-center gap-4 p-4 bg-white border rounded-md hover:-translate-y-0.5 hover:shadow-sm transition-all ${t.cls.includes("red") ? "border-red-200" : "border-slate-200"}`}>
                                <div className="w-12 text-center">
                                    {it.days_until < 0 ? (
                                        <Warning size={22} weight="fill" className="text-red-600 mx-auto" />
                                    ) : (
                                        <Clock size={22} weight="duotone" className="text-[#2563EB] mx-auto" />
                                    )}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="font-semibold truncate">{it.title}</p>
                                    <p className="text-xs text-slate-500 mt-0.5">{it.creditor_name} · {it.case_type}</p>
                                </div>
                                <div className="text-right">
                                    <p className="text-sm font-mono">{formatDateUS(it.deadline)}</p>
                                    <span className={`inline-block mt-1 px-2 py-0.5 rounded text-xs font-medium border ${t.cls}`}>
                                        {it.days_until < 0 ? `${Math.abs(it.days_until)}d overdue` : `${it.days_until}d`} · {t.tag}
                                    </span>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
